import type { ParamMatcher } from "@sveltejs/kit";

// This is for backwards compatibility with links pre-July 2025 (public beta).
// Only Suno and Modal and toposbio used us before then.
//
// Old URL: https://modal.com/notebooks/modal-labs/nb-123123123
// New URL: https://modal.com/notebooks/modal-labs/_/nb-123123123
//
// We use the new URL because the old URL overlaps with the dashboard at
// /notebooks/:workspace/:environment and we want to avoid this collision.
// Luckily no one has created any environments starting with "nb-" yet. So
// we'll just redirect the old URL to the new one for now.
//
// Eventually we can remove this code and matcher once enough time has passed,
// and links to old URLs have been removed from the wild.
export const match: ParamMatcher = (param) => {
  return param.match(/^nb-[a-zA-Z0-9]+$/) !== null;
};
